import { render, staticRenderFns } from "./CreatePropertyAdditionalCharge.vue?vue&type=template&id=05789457&"
import script from "./CreatePropertyAdditionalCharge.vue?vue&type=script&lang=js&"
export * from "./CreatePropertyAdditionalCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports